import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { buildApiUrl } from '../../../utils/apiUrl';
import { FaChevronDown, FaTimes } from 'react-icons/fa';
import '../../../assets/scss/Admin/StatisticsModal.scss';

const MultiSelect = ({ label, options, selected, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleOption = (option) => {
        const newSelected = selected.includes(option)
            ? selected.filter(item => item !== option)
            : [...selected, option];
        onChange(newSelected);
    };

    return (
        <div className="multi-select-container" ref={containerRef}>
            <label>{label}</label>
            <div className="multi-select-trigger" onClick={() => setIsOpen(!isOpen)}>
                <div className="selected-tags">
                    {selected.length === 0 ? (
                        <span className="placeholder">Velg {label.toLowerCase()}...</span>
                    ) : (
                        selected.length <= 2 ? (
                            selected.map(item => (
                                <span key={item} className="tag">
                                    {item}
                                    <FaTimes
                                        className="remove-tag"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleOption(item);
                                        }}
                                    />
                                </span>
                            ))
                        ) : (
                            <span className="tag">{selected.length} valgt</span>
                        )
                    )}
                </div>
                <FaChevronDown className={`arrow ${isOpen ? 'open' : ''}`} />
            </div>
            {isOpen && (
                <div className="multi-select-dropdown">
                    {options.map(option => (
                        <div
                            key={option}
                            className={`option ${selected.includes(option) ? 'selected' : ''}`}
                            onClick={() => toggleOption(option)}
                        >
                            <input
                                type="checkbox"
                                checked={selected.includes(option)}
                                readOnly
                            />
                            <span>{option}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

const StatisticsModal = ({ onClose, onGenerate }) => {
    const [packages, setPackages] = useState([]);
    const [locations, setLocations] = useState([]);
    const [filters, setFilters] = useState({
        packageChoice: [],
        location: [],
        stillbildevideo: false,
        animatedAd: false,
        hybridHome: false,
        startDate: '',
        endDate: '',
    });

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const response = await axios.get(buildApiUrl('statistics/filter-options'));
                setPackages(response.data.packages);
                setLocations(response.data.locations);
            } catch (error) {
                console.error('Error fetching filter options:', error);
            }
        };
        fetchOptions();
    }, []);

    const handleChange = (name, value) => {
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleSubmit = () => {
        onGenerate(filters);
    };

    return (
        <div className="statistics-modal-overlay">
            <div className="statistics-modal">
                <div className="modal-header">
                    <h2>Lag statistikk</h2>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <MultiSelect
                            label="Pakke"
                            options={packages}
                            selected={filters.packageChoice}
                            onChange={(val) => handleChange('packageChoice', val)}
                        />
                        <MultiSelect
                            label="Kontor"
                            options={locations}
                            selected={filters.location}
                            onChange={(val) => handleChange('location', val)}
                        />
                    </div>

                    <div className="section-label">Innhold & Valg</div>
                    <div className="checkbox-grid">
                        <label className="custom-checkbox">
                            <input
                                type="checkbox"
                                name="stillbildevideo"
                                checked={filters.stillbildevideo}
                                onChange={handleCheckboxChange}
                            />
                            <span className="checkmark"></span>
                            Stillbildevideo
                        </label>
                        <label className="custom-checkbox">
                            <input
                                type="checkbox"
                                name="animatedAd"
                                checked={filters.animatedAd}
                                onChange={handleCheckboxChange}
                            />
                            <span className="checkmark"></span>
                            Animert annonse
                        </label>
                        <label className="custom-checkbox">
                            <input
                                type="checkbox"
                                name="hybridHome"
                                checked={filters.hybridHome}
                                onChange={handleCheckboxChange}
                            />
                            <span className="checkmark"></span>
                            Hybrid/Hjemmekontor
                        </label>
                    </div>

                    <div className="section-label">Periode</div>
                    <div className="date-group">
                        <div className="date-field">
                            <label>Fra dato</label>
                            <input
                                type="date"
                                name="startDate"
                                value={filters.startDate}
                                onChange={(e) => handleChange('startDate', e.target.value)}
                            />
                        </div>
                        <div className="date-field">
                            <label>Til dato</label>
                            <input
                                type="date"
                                name="endDate"
                                value={filters.endDate}
                                onChange={(e) => handleChange('endDate', e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="cancel-btn" onClick={onClose}>Avbryt</button>
                    <button className="generate-btn" onClick={handleSubmit}>Lag statistikk</button>
                </div>
            </div>
        </div>
    );
};

export default StatisticsModal;
